"use client";

import { useState, useEffect } from "react";
import { useMediaQuery, VeBox, VeTypography } from "@packages/ui/mui";
import { VeButton } from "@packages/ui/components";

const CookieConsentBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const isTab = useMediaQuery("(max-width:900px)");

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setShowBanner(true);
    } else if (consent === "accepted") {
      // Load Google Analytics if already accepted
      loadGoogleAnalytics();
    }
  }, []);

  useEffect(() => {
    if (showBanner) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "";
    };
  }, [showBanner]);

  const loadGoogleAnalytics = () => {
    // Create and append the gtag script
    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = "https://www.googletagmanager.com/gtag/js?id=G-04LCZ92Y0Y";
    document.head.appendChild(script1);

    // Create and append the inline script
    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-04LCZ92Y0Y');
    `;
    document.head.appendChild(script2);
  };

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    loadGoogleAnalytics();
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookie-consent", "declined");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <>
      {/* Backdrop */}
      <VeBox
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 9998,
          animation: "fadeIn 0.3s ease-out",
          "@keyframes fadeIn": {
            from: {
              opacity: 0,
            },
            to: {
              opacity: 1,
            },
          },
        }}
      />
      {/* Banner */}
      <VeBox
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "#FFFFFF",
          borderTop: "6px solid #886BE8",
          boxShadow: "0px -2px 16px 0px rgba(0, 0, 0, 0.08)",
          padding: { xs: "16px", md: "32px" },
          zIndex: 9999,
          animation: "slideUp 0.3s ease-out",
          height: isTab ? "auto" : "144px",
          "@keyframes slideUp": {
            from: {
              transform: "translateY(100%)",
            },
            to: {
              transform: "translateY(0)",
            },
          },
        }}
      >
        <VeBox
          sx={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-start", md: "center" },
            gap: { xs: "16px", md: "24px" },
            justifyContent: "space-between",
          }}
        >
          <VeBox
            sx={{ flex: 1 }}
            display={"flex"}
            flexDirection={"column"}
            gap={"16px"}
          >
            <VeTypography variant="label1StrongMain">
              We respect your privacy
            </VeTypography>
            <VeTypography variant="label2Secondary">
              By choosing Accept all cookies, you allow us to store cookies on
              your device to support smoother navigation, analyse site usage,
              and improve overall experience.You may also choose to Manage
              preferences or Reject all cookies at any time.
            </VeTypography>
          </VeBox>
          <VeBox
            sx={{
              display: "flex",
              gap: "12px",
              flexDirection: "column",
              flexShrink: 0,
              width: { xs: "100%", md: "160px" },
            }}
          >
            <VeButton buttonVariant="contained" buttonClick={handleAccept}>
              Accept All
            </VeButton>
            <VeButton buttonVariant="outlined" buttonClick={handleDecline}>
              Reject All
            </VeButton>
          </VeBox>
        </VeBox>
      </VeBox>
    </>
  );
};

export default CookieConsentBanner;
